// extracted by mini-css-extract-plugin
export default {"Wrapper":"Usersettings_Wrapper__H6IXg"};